$(function() {

  $("#create_customer").on("submit", function() {
    var firstName = $("#first_name").val();
    var lastName = $("#last_name").val();
    var password = $("#password").val();
    var password2 = $("#password2").val();

    if (firstName == "") {
      alert("Please enter your first name!");
    }
    else if (lastName == "") {
      alert("Please enter your surname!");
    }
    else if (password.length < 6) {
      alert("Password should be at least 6 characters long!");
      return false;
    }
    else if (password != password2) {
      alert("Please confirm your password!");
      return false;
    }
  });

});
